export const defaultScrapedAffiliationsPagination = { skip: 0, limit: 20, currentPage: 1 };
